import React, { useState, useEffect, useCallback } from 'react';
import {prefix} from "../../wui-core/src/index"
import { SearchTabsProps } from './iTabs'

interface SearchTabsComponent extends React.FC<SearchTabsProps> {
    Item: any;
}

const SearchTabs: SearchTabsComponent = (props) => {
    const { children, clsfix = `${prefix}-search-tabs`, onChange = () => {}, value, ...others } = props;
    const [activeValue, setActiveValue] = useState(value);

    useEffect(() => {
        if ('value' in props && value != activeValue) setActiveValue(value);
    }, [value]);

    const childClick = useCallback((newActiveValue: string) => {
        setActiveValue(newActiveValue);
        onChange(newActiveValue);
    }, [onChange]);

    const getChildren = useCallback(() => {
        const childs: React.ReactNode[] = [];
        const childArray = React.Children.toArray(children);
        childArray.forEach((child: any, index) => {
            childs.push(React.cloneElement(child, {
                tabClick: childClick,
                active: child.props.value == activeValue,
                clsfix
            }));
            if (index < childArray.length - 1) childs.push(<span className={`${clsfix}-split`} key={`split-${index}`}>|</span>);
        });
        return childs;
    }, [children, clsfix, childClick, activeValue]);

    return (
        <div className={`${clsfix}`} {...others}>
            {getChildren()}
        </div>
    );
};

SearchTabs.Item = undefined; // 这个会在其他地方赋值

export default SearchTabs;
